var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_6200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.297 18.022l1.426-8h2.23l-1.382 8h-2.274z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.297 18.022l1.828-8h1.828l-1.382 8h-2.274z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.642 10.111c-.446-.177-1.16-.355-2.051-.355-2.23 0-3.834 1.111-3.834 2.711 0 1.2 1.114 1.822 2.006 2.222.891.4 1.159.667 1.159 1.022 0 .534-.713.8-1.338.8-.891 0-1.382-.133-2.14-.444l-.312-.133-.312 1.822c.535.222 1.516.444 2.542.444 2.363 0 3.923-1.11 3.923-2.8 0-.933-.58-1.644-1.917-2.222-.803-.4-1.293-.622-1.293-1.022 0-.356.401-.711 1.293-.711.758 0 1.293.133 1.694.31l.223.09.357-1.734z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.642 10.111c-.446-.177-1.16-.355-2.051-.355-2.23 0-3.433 1.111-3.433 2.711 0 1.2.713 1.822 1.605 2.222.891.4 1.159.667 1.159 1.022 0 .534-.713.8-1.338.8-.891 0-1.382-.133-2.14-.444l-.312-.133-.312 1.822c.535.222 1.516.444 2.542.444 2.363 0 3.923-1.11 3.923-2.8 0-.933-.58-1.644-1.917-2.222-.803-.4-1.293-.622-1.293-1.022 0-.356.401-.711 1.293-.711.758 0 1.293.133 1.694.31l.223.09.357-1.734z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.476 10.022c-.535 0-.937.044-1.16.578l-3.343 7.422h2.407l.446-1.333h2.853l.268 1.333h2.14l-1.873-8h-1.738zm-1.026 5.333c.134-.4.892-2.355.892-2.355s.178-.49.312-.8l.134.755s.445 2 .535 2.445H23.45v-.045z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.01 10.022c-.534 0-.936.044-1.159.578l-3.878 7.422h2.407l.446-1.333h2.853l.268 1.333h2.14l-1.873-8h-1.203zm-1.56 5.333c.178-.444.892-2.355.892-2.355s.178-.49.312-.8l.134.755s.445 2 .535 2.445H23.45v-.045z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 15.623l-.224-1.156c-.4-1.333-1.694-2.8-3.12-3.51l2.006 7.11h2.407l3.611-8H8.473l-2.274 5.556z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 15.623l-.224-1.156c-.4-1.333-1.694-2.8-3.12-3.51l2.006 7.11h2.407l3.611-8H8.92L6.2 15.623z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022l.401.089c2.854.666 4.815 2.355 5.573 4.355l-.802-3.777c-.134-.534-.535-.667-1.026-.667H0z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022c2.853.667 5.216 2.4 5.974 4.4l-.758-3.156a1.088 1.088 0 00-1.07-.844L0 10.022z",
    fill: "#F7981D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022c2.853.667 5.216 2.4 5.974 4.4l-.535-1.733c-.134-.534-.312-1.067-.936-1.29L0 10.023z",
    fill: "#ED7C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_6200"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28.088v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.67c72dccd00fe5eba7790269ce3536d4.svg";
export { ForwardRef as ReactComponent };